import type { ComponentProps } from "react";

export type ButtonVariant = "primary" | "ghost" | "danger";

const BASE =
  "inline-flex items-center justify-center gap-2 border px-3 py-1.5 text-xs transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-50";
const VARIANT: Record<ButtonVariant, string> = {
  primary:
    "border-signal text-signal shadow-[inset_0_0_12px_rgb(62_230_255/0.12)] hover:bg-signal/10 enabled:active:bg-signal/20",
  ghost: "border-line text-text hover:border-line-strong hover:text-strong",
  danger: "border-error/60 text-error hover:bg-error/10",
};

export function Button({
  variant = "ghost",
  className = "",
  type = "button",
  ...props
}: ComponentProps<"button"> & { variant?: ButtonVariant }) {
  return <button type={type} className={`${BASE} ${VARIANT[variant]} ${className}`} {...props} />;
}
